import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HouseholdSize from './household-size';
import HouseholdSizeDetail from './household-size-detail';
import HouseholdSizeUpdate from './household-size-update';
import HouseholdSizeDeleteDialog from './household-size-delete-dialog';

const HouseholdSizeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HouseholdSize />} />
    <Route path="new" element={<HouseholdSizeUpdate />} />
    <Route path=":id">
      <Route index element={<HouseholdSizeDetail />} />
      <Route path="edit" element={<HouseholdSizeUpdate />} />
      <Route path="delete" element={<HouseholdSizeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HouseholdSizeRoutes;
